import React, { useMemo } from 'react';

import _ from 'lodash';
import dayjs from 'dayjs';
import { Flex } from 'antd';
import { CalendarOutlined } from '@ant-design/icons';
import { WidgetStatistic } from 'src/pages/dashboard/styles';
import useOccurrences from 'src/pages/dashboard/contexts/useOccurrences';
import {
	CardTitle,
	CardData,
	IconArea
} from 'src/pages/dashboard/components/cards/styles';

export default function DayWithMostOccurrences() {
	const { occurrences, } = useOccurrences();

	const data = useMemo(() => {
		const alertOccurrences = occurrences.filter(occ => !occ.is_recovery);

		const groupedByDate = _.groupBy(alertOccurrences, (occurrence) => 
			dayjs(occurrence.creation_date).format('DD/MM/YYYY')
		);

		const dateCounts = _.mapValues(groupedByDate, (group) => 
			group.length
		);

		const maxDate = _.maxBy(Object.keys(dateCounts), (date) => 
			dateCounts[date]
		);

		if(!maxDate){
			return {
				date: '',
				count: 0,
			};
		}

		return {
			date: maxDate,
			count: dateCounts[maxDate],
		};
	}, [ occurrences, ]);

	return (
		<Flex
			gap={16}
			justify='space-between'
			style={{ width: '100%', }}
		>
			<Flex vertical gap={4}>
				<CardTitle>
                    Dia com mais ocorrências:
				</CardTitle>
				<CardData>
					<span>{data.date}</span>
					<WidgetStatistic>
						{data.count}
					</WidgetStatistic>
				</CardData>
			</Flex>
			<IconArea>
				<CalendarOutlined style={{ fontSize: 24, color: '#fff', }} />
			</IconArea>
		</Flex>
	);
}
